import { render } from "./umiAudioInfoView.vue?vue&type=template&id=4059d17a&scoped=true&ts=true"
import script from "./umiAudioInfoView.vue?vue&type=script&lang=ts"
export * from "./umiAudioInfoView.vue?vue&type=script&lang=ts"

import "./umiAudioInfoView.vue?vue&type=style&index=0&id=4059d17a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4059d17a"]])

export default __exports__